// Wizard actions must never cross tabs. syncReduxActions skips broadcasting any
// action whose type starts with this prefix, so every onboarding action constant
// has to carry it — build them with onboardingActionType() rather than writing
// the string out in the house style ("ONBOARDING_SET_SESSION"), which would be
// broadcast like any other action.
//
// The receiver-side company gate is not enough on its own: the wizard lives in
// the same SPA as the logged-in app, so a tab that still has a selected company
// from a restored session sends that company id with the action, and a
// logged-in tab on the same company accepts it and applies wizard state to the
// user's store.
export const ONBOARDING_ACTION_PREFIX = "onboarding/";

export const onboardingActionType = <T extends string>(name: T) => `${ONBOARDING_ACTION_PREFIX}${name}` as const;

export const SET_INVITE_TOKEN = onboardingActionType("SET_INVITE_TOKEN");
export const SESSION_MINTED = onboardingActionType("SESSION_MINTED");
export const SESSION_EXPIRED = onboardingActionType("SESSION_EXPIRED");
export const SET_COMPANY_NAME = onboardingActionType("SET_COMPANY_NAME");
export const PERSON_SESSION_SAVED = onboardingActionType("PERSON_SESSION_SAVED");
export const PERSON_SESSION_ENDED = onboardingActionType("PERSON_SESSION_ENDED");
